import { motion } from 'framer-motion';

export default function AuthHeader() {
    return (
        <div className="text-center mb-8">
            <motion.img
                src="/logo.png"
                alt="PitchMe.AI"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="w-16 h-16 rounded-2xl mx-auto mb-6 shadow-[0_0_30px_rgba(255,255,255,0.15)]"
            />
            <motion.h1
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-3xl font-bold text-white mb-3"
            >
                Welcome to PitchMe.AI
            </motion.h1>
            <motion.p
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-zinc-400"
            >
                Sign in to continue your interview preparation
            </motion.p>
        </div>
    );
}
